<template>
  <Teleport to="#modal">
    <div v-if="isOpen">
      <!-- The backdrop, rendered as a fixed sibling to the panel container -->
      <div class="fixed inset-0 bg-black/30 z-50" aria-hidden="true" @click="setIsOpen(false)" />

      <!-- Full-screen container to center the panel -->
      <div class="fixed inset-0 flex items-end px-13 py-10 z-50 overflow-y-auto">
        <div class="panel overflow-y-scroll bg-white w-full max-w-xl p-5 overflow-auto max-h-full md:h-fit relative">
          <div><slot name="title"></slot></div>
          <div>
            <slot></slot>
          </div>

          <div class="absolute top-0 right-0 p-5 cursor-pointer" @click="setIsOpen(false)">
            <ph-x class="inline-block" size="24" />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, toRefs } from 'vue'
import { PhX } from '@dnlsndr/vue-phosphor-icons'

const props = defineProps<{
  isOpen: boolean
}>()
const emit = defineEmits(['update:isOpen'])

const { isOpen } = toRefs(props)
function setIsOpen(value: boolean) {
  emit('update:isOpen', value)
}
</script>
